import React from "react";
import { Nav } from "@/components/navigation/Navbar";
import * as Text from "@/components/text";
import ReactMarkdown from "react-markdown";
import { NextSeo } from "next-seo";
import { Disclosure } from "@headlessui/react";
import { MinusSmIcon, PlusSmIcon } from "@heroicons/react/solid";
import { getStrapiImage } from "@/utils/strapiFunctions";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import Image from "next/legacy/image";
import Link from "next/link";

export default function ContactUs({ mediaCenter }) {
  return (
    <>
      <NextSeo
        title="Contáctanos - Ambulante"
        description="Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante"
        canonical={`https://ambulante.org/vacantes}`}
        openGraph={{
          url: `https://ambulante.org/vacantes`,
          title: "Contáctanos - Ambulante",
          description:
            "Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante",
          site_name: "Ambulante",
        }}
      />

      <section className="amb-container">
        {mediaCenter.cover_image ? (
          <div className="relative h-[500px] lg:h-[600px]">
            <div className="absolute inset-0">
              <img
                className="object-cover w-full h-full"
                src={getStrapiImage(mediaCenter.cover_image)}
                alt="Ambulante Contáctanos"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
          </div>
        ) : null}

        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="mt-8 lg:col-span-5 lg:mt-16">
            <Text.Display as="h1" size="sm">
              Contáctanos
            </Text.Display>
            <h3 className="text-lg tracking-wider text-gray-500 uppercase mt-7 lg:mt-14">
              Compartir
            </h3>
            <div className="flex gap-5 mt-4 lg:mt-8">
              <Link
                href="https://www.facebook.com/AmbulanteAC"
                passHref
                target="_blank"
              >
                <Image
                  alt="facebook icon"
                  className="opacity-60 hover:opacity-100"
                  width={25}
                  height={25}
                  src="/next_assets/img/fb_icon.svg"
                />
              </Link>
              <Link
                href="https://twitter.com/Ambulante"
                passHref
                target="_blank"
              >
                <Image
                  alt="twitter icon"
                  className="opacity-60 hover:opacity-100"
                  width={25}
                  height={25}
                  src="/next_assets/img/twitter_icon.svg"
                />
              </Link>
              <Link
                href="mailto:?subject=Algo interesante en Ambulante.org&body=https://www.ambulante.org/contacto/"
                passHref
                target="_blank"
              >
                <Image
                  alt="email icon"
                  className="opacity-60 hover:opacity-100"
                  width={25}
                  height={25}
                  src="/next_assets/img/email_icon.svg"
                />
              </Link>
            </div>
          </div>
          <div className="mt-10 lg:col-span-7 lg:mt-0">
            <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
              {mediaCenter.qa.length > 0
                ? mediaCenter?.qa.map((qa, index) => (
                  <Disclosure as="div" key={qa.id} className="pt-6">
                    {({ open }) => (
                      <>
                        <dt>
                          <Disclosure.Button className="flex items-start justify-between w-full text-left text-gray-900">
                            <span className="text-base font-semibold leading-7">
                              {qa.Pregunta}
                            </span>
                            <span className="flex items-center ml-6 h-7">
                              {open ? (
                                <MinusSmIcon
                                  className="w-6 h-6"
                                  aria-hidden="true"
                                />
                              ) : (
                                <PlusSmIcon
                                  className="w-6 h-6"
                                  aria-hidden="true"
                                />
                              )}
                            </span>
                          </Disclosure.Button>
                        </dt>
                        <Disclosure.Panel as="dd" className="pr-12 mt-2">
                          <ReactMarkdown
                            as="div"
                            className="font-body  mt-10 prose-h2:uppercase hover:prose-a:underline  prose-li:my-2 lg:max-w-[100ch]"
                          >
                            {qa.Respuesta.replace(/<br>/g, "&nbsp; \n")}
                          </ReactMarkdown>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ))
                : null}
            </dl>
          </div>
        </div>



      </section>
    </>
  );
}

export async function getServerSideProps() {
  const q = qs.stringify({
    populate: {
      qa: "*",
      cover_image: "*",
    },
  });
  const { data } = await apiClient.get(`/api/contacto?${q}`);

  return {
    props: {
      mediaCenter: data.data.attributes,
    },
  };
}

ContactUs.getLayout = function getLayout(page) {
  return (
    <div>
      <div className="bg-white amb-container">
        <Nav theme="light" />
      </div>
      <div>{page}</div>
    </div>
  );
};
